const { forEach } = require("jszip");

/*Profile*/
if(window.location.pathname.includes("placement/hotels")){

    $(window).on("/api/note/create.success", function(e, response){

        if(typeof response['note']['parent'] == 'undefined') return;
        if(typeof response['note']['parent']['hotel'] == 'undefined') return;
        app.leave_note = '';
        app.notes.unshift(response['note']);
    });

    // Update the check_in_date and check_out_date of the hotel placement
    $(window).on("/api/hotel_placement_room/update.success", function(e, response){
        app.placement.hotel_placements.forEach((item, index)=>{
            item.rooms.forEach((room, room_index)=>{
                if(room.id == response.Updated.id){
                    app.placement.hotel_placements[index].check_in_date = response.HotelPlacement.check_in_date;
                    app.placement.hotel_placements[index].check_out_date = response.HotelPlacement.check_out_date;
                }
            })
        })
    });

    // Echo.private(`placement.${app.placement.id}.hotel_notes`)
    //     .listen('NoteChange', (e) => {
    //         app.notes = e.notes;
    //     });

    
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/hotel.js